<div id="ngb-nav-0-panel">
    <!-- Invoice List View -->
    <div class="container p-0" *ngIf="isUpdateInProgress && showInvoiceSummary">
        <app-obpp-invoice-summary
            [invoiceData]="invoiceData"
            [accountName]="accountName"
            [isViewOnly]="isViewOnly"
            (payNowClicked)="onInvoiceLevelPayNow($event)"
            (requestInvoicePDF)="getInvoicePDF($event)">
        </app-obpp-invoice-summary>
    </div>

    <!-- Cart + Payment View -->
    <div class="container cart-view" *ngIf="!isUpdateInProgress">

        <div role="tabpanel" class="tab-pane" id="accountsummary">
            <div class="row" *ngIf="!paymentSuccessFlag">
                <div class="col-md-12 d-flex flex-wrap top-section">
                    <div class="col-md-6">
                        <div class="account-info well">
                            <img class="icon" src="../../../../assets/images/square-exclamation.svg" alt="clock-icon" />
                            <label>{{ "PLEASE_ALLOW_UPTO" | translate }}
                                <span class="bold">{{ "ALLOWABLE_HOURS" | translate }}</span>
                                {{ "REFLECTED_RECEIVED_PAYMENTS" | translate }}
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card shadow payment-card payment-amount">
                            <div class="amount-name-card m-0">
                                <label class="tot-pay-label">{{
                                    "TOTAL_PAYMENT_KEY" | translate
                                    }}</label>
                            </div>
                            <div class="col-md-12 amount-card-focus amount-card shadow m-0">
                                <label class="col-md-10 total-amt-font-focus text-center">
                                    {{ getCartTotal() | currency }} ({{ paymentCurrency }})</label>
                                <img class="m-auto"
                                    [src]="paymentCurrency === 'CAD' ? '/../../assets/images/CAN FLAG.svg' : '/../../assets/images/US FLAG.svg'"
                                    alt="flag" />
                            </div>
                            <label class="text-center">
                                <input type="checkbox" class="form-check-input m-0" [(ngModel)]="isEmailRequired"
                                    (keydown.enter)="selectCheckBox($event)" [ngModelOptions]="{ standalone: true }" [disabled]="showIFrame"/>
                                {{ "ALTERNATE_EMAIL_AT_TEXT" | translate }}
                            </label>
                            <div *ngIf="isEmailRequired">
                                <input type="email" class="form-control emailField" email="true" id="alternativeEmail"
                                    [(ngModel)]="notifyEmail" [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'LOGIN_EMAIL_PLACEHOLDER_KEY' | translate}}" [disabled]="showIFrame"
                                    [class]="(!isValidEmail(notifyEmail) && isEmailRequired)?' is-invalid':''" />
                                <div *ngIf="!isValidEmail(notifyEmail) && isEmailRequired">
                                    <span class="error-block">{{
                                        "EMAIL_REQUIRED" | translate
                                        }}</span>
                                </div>
                            </div>
                            <div class="form-group text-center">
                                <button class="btn btn-primary btn-block primary-btn"
                                    [disabled]="isButtonDisabled()" (click)="loadIFrame()" role="presentation"
                                    tabindex="0" (keydown.enter)="loadIFrame()">
                                    {{ "INITIATE_PAYMENT" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Invoice Cart Table -->
                <div class="col-md-12 cart-table-section">
                    <div class="row col-md-12">
                        <label class="txt-puro-blue f-20">
                            {{ "INVOICES_IN_CART" | translate }}
                        </label>
                    </div>

                    <div class="col-md-12">
                        <div class="panel-body bg-gray panel-body-invoicesummary">
                            <table class="table table-striped t-inv" aria-describedby="panel">
                                <thead class="h-30">
                                    <th scope="col">{{ "ACCOUNT_NUMBER_TEXT" | translate }}</th>
                                    <th scope="col">{{ "INVOICE_NUMBER_TEXT" | translate }}</th>
                                    <th scope="col" class="text-right">{{ "BALANCE_DUE" | translate }}</th>
                                    <th scope="col" class="text-right">{{ "TL_PAYAMNT" | translate }}</th>
                                    <th scope="col" class="text-center">{{ "CURRENCY_TEXT" | translate }}</th>
                                    <th scope="col">{{ "REMOVE_KEY" | translate }}</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let invoice of accountsList" class="tr-table">
                                        <td>{{ invoice.accounts.accountNumber }}</td>
                                        <td>{{ invoice.invoiceNumber }}</td>
                                        <td *ngIf="!(invoice.balanceDue == 0.0)" class="text-right">
                                            {{ invoice.balanceDue | currency }}
                                        </td>
                                        <td *ngIf="invoice.balanceDue == 0.0" class="text-right"></td>
                                        <td class="text-right">{{ invoice.paymentAmount | currency }}</td>
                                        <td class="text-center">{{ invoice.currency }}</td>
                                        <td>
                                            <img title="{{ 'REMOVE_KEY' | translate }}"
                                                class="cursor-pointer icon icon-cart-remove remove-btn"
                                                src="assets/images/blueclose.svg"
                                                alt="{{ 'REMOVE_KEY' | translate }}"
                                                (click)="removeInvoice(invoice)" tabindex="0"
                                                (keydown.enter)="removeInvoice(invoice)"/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-5 form-group addAnotherInvoiceCartPage">
                            <button class="btn cta-blue info-btn sec-btn w-auto" (click)="goBackSummaryPage()">
                                {{ "GO_BACK_TEXT" | translate }}
                            </button>
                        </div>
                    </div>

                    <div *ngIf="declinedMessage && !paymentSuccessFlag && !showIFrame">
                        <div class="row col-md-12">
                            <label class="txt-puro-red f-20">
                                {{ "DECLINED_TRANSACTION_TEXT" | translate }}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="card ifrmae-card" *ngIf="showIFrame">
                    <app-select-payment-options
                        [invoiceList]="selectedInvoiceList"
                        [totalAmount]="getCartTotal()"
                        [userEmail]="uname"
                        [alternativeEmailHandler]="receiptEmailHandler(isEmailRequired)"
                        [currentCurrency]="paymentCurrency"
                        (paymentSuccessFlag)="paymentSuccessHandler($event)"
                        (cancelButtonIsClicked)="goBackSummaryPage()"
                        (paymentFailureFlag)="paymentFailureHandler($event)"
                        (isMonerisIframeRendered)="disableRemoveInvoiceHandler($event)"
                    ></app-select-payment-options>
                </div>
            </div>
        </div>
    </div>

    <!-- Receipt View -->
    <div class="container" *ngIf="paymentSuccessFlag">
        <div class="row col-md-12">
            <h2>{{ "THANK_YOU_TEXT" | translate }}</h2>
        </div>
        <br /><br />
        <div class="form-horizontal quickpay-form p-4">
            <div class="row p-bottom-dp no-print">
                <div class="form-group col-md-3">
                    <label class="control-label">{{ "PAYMENT_RECEIPT_TEXT" | translate }}</label>
                </div>
                <div class="col-md-3">
                    <button class="btn btn-primary btn-block primary-btn" (click)="printPage()">
                        {{ "PRINT_TEXT" | translate }}
                    </button>
                </div>
            </div>

            <!-- Pay Amount -->
            <div class="row">
                <div class="form-group col-md-3">
                    <label class="control-label">{{ "PAYMENT_AMT_TEXT" | translate }}</label>
                </div>
                <div class="col-md-3" *ngIf="receiptGeneric.totalPayAmount != '' && receiptGeneric.totalPayAmount != null">
                    <label name="qp-invoiceNumber" class="control-label currency">{{ receiptGeneric.totalPayAmount | currency }}{{ paymentCurrency }}</label>
                </div>
            </div>

            <!-- Card Number -->
            <div class="row" *ngIf="receiptGeneric.ccNumber != '' && receiptGeneric.ccNumber != null">
                <div class="form-group col-md-3">
                    <label class="control-label">{{ "CARD_NUMBER_TEXT" | translate }}</label>
                </div>
                <div class="col-md-4">
                    <label name="qp-invoiceNumber" class="control-label">{{receiptGeneric.ccNumber}}</label>
                    <span>
                        <img *ngIf="receiptGeneric.ccType === 'V'" src="assets/images/icon-cc-visa.png" alt="Visa" />
                        <img *ngIf="receiptGeneric.ccType === 'M'" src="assets/images/icon-cc-mastercard.png" alt="MasterCard" />
                        <img *ngIf="receiptGeneric.ccType === 'AX'" src="assets/images/icon-cc-amex.png" alt="American Express" />
                    </span>
                </div>
            </div>

            <!-- Date -->
            <div class="row">
                <div class="form-group col-md-3">
                    <label class="control-label">{{ "DATE_TEXT" | translate }}</label>
                </div>
                <div class="col-md-3">
                    <label name="qp-InvoiceDate" class="control-label" *ngIf="receiptGeneric.paymentDate != '' && receiptGeneric.paymentDate != null">{{ receiptGeneric.paymentDate }}</label>
                    <label name="qp-InvoiceDate" class="control-label" *ngIf="receiptGeneric.eftPaymentDate != '' && receiptGeneric.eftPaymentDate != null">{{ receiptGeneric.eftPaymentDate }}</label>
                </div>
            </div>

            <!-- Reference Number -->
            <div class="row" *ngIf="receiptGeneric.referenceNumber != '' && receiptGeneric.referenceNumber != null">
                <div class="form-group col-md-3">
                    <label class="control-label">{{ "CONFIRMATION_NUMBER_TEXT" | translate }}</label>
                </div>
                <div class="col-md-3">
                    <label name="qp-InvoiceDate" class="control-label">{{receiptGeneric.referenceNumber}}</label>
                </div>
            </div>

            <!-- EFT Reference Number -->
            <div class="row" *ngIf="receiptGeneric.eftReferenceNbr != '' && receiptGeneric.eftReferenceNbr != null">
                <div class="form-group col-md-3">
                    <label class="control-label">{{ "REFERENCE_TEXT" | translate }}</label>
                </div>
                <div class="col-md-3">
                    <label name="qp-InvoiceDate" class="control-label">{{receiptGeneric.eftReferenceNbr}}</label>
                </div>
            </div>

            <!-- Receipt Email -->
            <div class="row p-bottom-dp" *ngIf="receiptGeneric.emailReceipt != '' && receiptGeneric.emailReceipt != null">
                <div class="form-group col-md-3">
                    <label class="control-label">{{ "QUICKPAY_ALERT_TEXT" | translate }}</label>
                </div>
                <div class="col-md-3">
                    <label name="qp-InvoiceDate" class="control-label">{{ receiptGeneric.emailReceipt }}</label>
                    <label *ngIf="isEmailRequired" name="qp-InvoiceDate" class="control-label">{{ notifyEmail }}</label>
                </div>
            </div>

            <!-- Invoice table -->
            <div class="row col-md-8 t-inv-div" *ngIf="receiptGeneric.invoiceList != null">
                <table class="table table-striped t-inv" aria-describedby="card">
                    <thead>
                        <th scope="col">{{ "ACCOUNT_NUMBER_TEXT" | translate }}</th>
                        <th scope="col">{{ "INVOICE_NUMBER_TEXT" | translate }}</th>
                        <th scope="col" class="text-right">{{ "BALANCE_DUE" | translate }}</th>
                        <th scope="col" class="text-right">{{ "TL_PAYAMNT" | translate }}</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let invoice of receiptGeneric.invoiceList">
                            <td>{{ invoice.accountNumber }}</td>
                            <td>{{ invoice.invoiceNumber }}</td>
                            <td *ngIf="!(invoice.balanceDue == 0.0)" class="text-right">
                                {{ invoice.balanceDue | currency }}
                            </td>
                            <td *ngIf="invoice.balanceDue == 0.0" class="text-right"></td>
                            <td class="text-right">{{ invoice.paymentAmount | currency }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Return to Account Summary -->
        <div class="form-group p-4 no-print">
            <div class="row col-md-12">
                <div class="col-md-4">
                    <button class="btn btn-primary btn-block" (click)="resetToSummary()" tabindex="0" (keydown.enter)="resetToSummary()">
                        {{ "RET_ACCT_SUMMARY_TEXT" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
